<template>
  <path
    d="M19 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00024C21 3.90024 20.1 3.00024 19 3.00024ZM17 8.00024H15.58V11.3302H13V14.6602H10.42L10.45 18.0002H7C6.45 18.0002 6 17.5502 6 17.0002C6 16.4502 6.45 16.0002 7 16.0002H8.42V12.6702H11V9.33024H13.58V6.00024H17C17.55 6.00024 18 6.45024 18 7.00024C18 7.55024 17.55 8.00024 17 8.00024Z"
  />
</template>
